import { ActionsTable } from "../../../Actions/ActionsTable";

export function GroupActionsTable() {
  return (
    <ActionsTable omitColumns={ [] } />
  );
}
